const config = {
    api: {
        baseUrl: process.env.REACT_APP_API_BASEURL,
    },
};

export default config;
